import { toInteger } from "lodash";

import ArtifactSidebarContent from "./artifact-sidebar-content";

const ArtifactSidebar = ({
  artifactId,
  meetingId,
  meetingGroupId,
  onClose,
}: {
  artifactId: number;
  meetingId?: number;
  meetingGroupId?: number;
  onClose: (option: { redirect: boolean }) => void;
}) => {
  return (
    <ArtifactSidebarContent
      artifactId={artifactId}
      meetingId={meetingId ? toInteger(meetingId) : undefined}
      meetingGroupId={meetingGroupId ? toInteger(meetingGroupId) : undefined}
      onClose={onClose}
    />
  );
};

export default ArtifactSidebar;
